// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Thanks__container{margin:64px auto;width:200px}\n", ""]);
// Exports
exports.locals = {
	"container": "Thanks__container"
};
module.exports = exports;
